import EfSwiperCard from '@elem/ui/ef-swiper-card';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const lists = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1721183383843/4%20charging%20method_01.jpg',
            title: t('H_card1_title'),
            desc: t('H_card1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1721183407143/4%20charging%20method_03.jpg',
            title: t('H_card2_title'),
            desc: t('H_card2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1721183396660/4%20charging%20method_02.jpg',
            title: t('H_card3_title'),
            desc: t('H_card3_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1721183418972/4%20charging%20method_04.jpg',
            title: t('H_card4_title'),
            desc: t('H_card4_desc'),
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec" />
            <EfSection title={t('H_title')} desc={t('H_desc')} />
            <EfSwiperCard lists={lists} />
            <EfSpec className="spec-80" />
        </div>
    );
}
